import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { LoginService } from '../../login';
import { ErrorHandlerService } from '../../services';
var CampusConnectionsComponent = /** @class */ (function () {
    function CampusConnectionsComponent(dashboardService, errorHandlerService, loginService, router) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.loginService = loginService;
        this.router = router;
        this.campusConnection = [];
        this.mynetworkcheck = "false";
        this.eduInstresults = [];
        this.eduInst = [];
        this.connectionfilter = {};
        this.countries = [];
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        //console.log(this.data.storage.campusConnection.userid);
    }
    CampusConnectionsComponent.prototype.searcheduinst = function (event) {
        this.eduInstresults = this.filtereduins(event.query, this.eduInst);
    };
    CampusConnectionsComponent.prototype.filtereduins = function (query, eduInst) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        var filtered = [];
        for (var i = 0; i < eduInst.length; i++) {
            var eduinst = eduInst[i];
            console.log(eduinst);
            if (eduinst.educationalInstitutionFullName != null) {
                if (eduinst.educationalInstitutionFullName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(eduinst.educationalInstitutionFullName);
                }
            }
        }
        return filtered;
    };
    CampusConnectionsComponent.prototype.myNetworkCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.inMyNetworkFilterCriteria = "true";
            console.log(this.connectionfilter);
            this.getSearchData();
        }
    };
    CampusConnectionsComponent.prototype.awaitResCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.awaitingResponseFilterCriteria = "true";
            console.log(this.connectionfilter);
            this.getSearchData();
        }
    };
    CampusConnectionsComponent.prototype.professorsCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.professors = "true";
            console.log(this.connectionfilter);
            this.getSearchData();
        }
    };
    CampusConnectionsComponent.prototype.studentsCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.students = "true";
            console.log(this.connectionfilter);
            this.getSearchData();
        }
    };
    CampusConnectionsComponent.prototype.alumniCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.alumni = "true";
            console.log(this.connectionfilter);
            this.getSearchData();
        }
    };
    CampusConnectionsComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    CampusConnectionsComponent.prototype.campusConnectionLoadM = function () {
        var _this = this;
        var s1 = this.dashboardService.campusConnectionsLoadMore(this.connectionfilter).subscribe(function (data) {
            data.forEach(function (element) {
                _this.campusConnection.push(element);
            });
        }, function (error) { _this.handleError(error); });
        this.subscriptions.push(s1);
    };
    CampusConnectionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var s2 = this.loginService.eduins().subscribe(function (data) { _this.eduInst = data; }, function (error) { console.log(error); _this.handleError(error); });
        this.subscriptions.push(s2);
        var s3 = this.loginService.country().subscribe(function (data) { _this.countries = data; }, function (error) { _this.handleError(error); });
        this.subscriptions.push(s3);
        var s4 = this.dashboardService.campusConnections(this.connectionfilter).subscribe(function (data) { _this.campusConnection = data; console.log(_this.campusConnection); }, function (error) { _this.handleError(error); });
        this.subscriptions.push(s4);
    };
    CampusConnectionsComponent.prototype.getSearchData = function () {
        var _this = this;
        return this.dashboardService.campusConnections(this.connectionfilter).subscribe(function (data) {
            _this.campusConnection = data;
            console.log(_this.campusConnection);
        }, function (error) {
            _this.handleError(error);
        });
    };
    CampusConnectionsComponent.prototype.onChange = function () {
        console.log(this.connectionfilter);
        this.getSearchData();
        // this.loginService.state(countryid).subscribe(
        //   data => {this.states = data;},
        //   error => {}
        // );
    };
    CampusConnectionsComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    CampusConnectionsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return CampusConnectionsComponent;
}());
export { CampusConnectionsComponent };
//# sourceMappingURL=campusConnections.component.js.map